module.exports = __webpack_public_path__ + "media/images/webpage/coupons/coupon/cover-pc-aab54ac18491ba3a5a0a246a9c3337f0.webp";